import React from 'react'
import Low from './Low'

const LevelDefault = ({ style, low }) => <Level style={style} low={low} />

export default LevelDefault

const Level = ({ style, low }) => {
  const svgStyle = { fill: '#284047', ...style, stroke: 'none' }
  return (
    <svg
      enableBackground='new -60.658 -180.5 100 100'
      style={svgStyle}
      viewBox='-60.658 -180.5 100 100'
    >
      <path d='M-10.657-166.882c-4.528,0-13.091-0.44-13.091-2.107v-2.443c0-1.666,8.563-2.106,13.091-2.106
        c4.527,0,13.089,0.44,13.089,2.106v2.443C2.432-167.323-6.13-166.882-10.657-166.882z M-10.657-173.039
        c-8.267,0-12.591,1.046-12.591,1.606v2.443c0,0.561,4.324,1.607,12.591,1.607c8.266,0,12.589-1.046,12.589-1.607v-2.443
        C1.932-171.993-2.392-173.039-10.657-173.039z'
      />
      <path d='M-10.657-154.141c-17.527,0-36.155-1.448-36.155-4.132c0-0.138,0.112-0.25,0.25-0.25
        s0.25,0.112,0.25,0.25c0,1.484,12.697,3.632,35.655,3.632c22.957,0,35.654-2.147,35.654-3.632c0-0.138,0.112-0.25,0.25-0.25
        s0.25,0.112,0.25,0.25C25.497-155.589,6.869-154.141-10.657-154.141z'
      />
      <path d='M-45.569-116.943c-1.155,0.851-1.155,1.459-1.155,1.66c0,0.615,0.633,1.217,1.163,1.613l0.589,0.439
        v1.053c5.561,2.938,18.792,4.886,34.198,4.886c9.801,0,19.019-0.794,25.954-2.235c3.959-0.822,6.875-1.787,8.724-2.876v-0.94
        l0.542-0.44c0.644-0.524,0.97-1.029,0.97-1.5c0-0.179,0-0.724-0.967-1.508l-0.544-0.441v-4.045
        c-1.964,0.817-4.82,1.52-8.627,2.125c-7.001,1.113-16.293,1.726-26.167,1.726c-9.875,0-19.168-0.613-26.168-1.726
        c-3.379-0.537-5.999-1.147-7.914-1.844v3.613L-45.569-116.943z'
      />
      <path d='M-45.718-125.833c-0.505,0.285-1.108,0.718-1.108,1.152c0,0.341,0.374,0.727,1.11,1.144l0.743,0.422
        v1.012c1.862,0.724,4.561,1.369,8.078,1.928c6.948,1.104,16.183,1.713,26.005,1.713c9.82,0,19.055-0.608,26.004-1.713
        c4.002-0.636,6.94-1.381,8.79-2.223v-0.824l0.698-0.429c0.917-0.566,0.917-0.916,0.917-1.031c0-0.379-0.501-0.77-0.921-1.031
        l-0.694-0.43v-6.021c-1.952,0.658-4.704,1.228-8.327,1.724c-7.016,0.958-16.326,1.486-26.214,1.486
        c-9.887,0-19.197-0.528-26.215-1.486c-3.492-0.478-6.181-1.024-8.12-1.655v5.84L-45.718-125.833z'
      />
      <path d='M-36.712-131.464c6.973,0.952,16.233,1.477,26.075,1.477c9.843,0,19.103-0.525,26.074-1.477
        c3.75-0.513,6.581-1.114,8.467-1.794v-0.906l0.8-0.408c0.8-0.408,0.922-0.679,0.924-0.681c0.005-0.021,0.005-0.101,0.005-0.154
        c0-0.32-0.659-0.699-0.941-0.848l-0.789-0.411v-6.273c-1.949,0.559-4.727,1.041-8.437,1.459
        c-7.027,0.793-16.347,1.23-26.245,1.23s-19.217-0.437-26.244-1.23c-3.363-0.38-6.021-0.824-7.951-1.327v6.063l-0.832,0.399
        c-0.711,0.341-1.136,0.691-1.136,0.938c0,0.049,0,0.132,0.005,0.152c0.001,0.003,0.146,0.318,1.121,0.777l0.841,0.397v0.897
        C-43.087-132.534-40.326-131.958-36.712-131.464z'
      />
      <path d='M-10.845-95.589c17.624,0,29.857-2.683,34.749-5.779v-0.885l0.523-0.44
        c0.769-0.647,1.159-1.274,1.159-1.862c0-0.625-0.39-1.269-1.16-1.918l-0.522-0.44v-4.305c-1.956,1.034-4.774,1.929-8.514,2.704
        c-7.003,1.456-16.294,2.257-26.165,2.257c-12.987,0-27.485-1.488-34.198-4.757v3.944l-0.565,0.44
        c-0.9,0.702-1.355,1.399-1.355,2.074c0,0.647,0.456,1.33,1.354,2.029l0.566,0.44v1.128
        C-38.686-97.427-23.938-95.589-10.845-95.589z'
      />
      <path d='M-10.845-94.554c-12.503,0-27.171-1.657-34.128-5.24v6.406c0,0.399,1.586,2.221,9.347,3.831
        c6.686,1.387,15.597,2.151,25.091,2.151c9.494,0,18.404-0.764,25.09-2.151c7.762-1.61,9.348-3.432,9.348-3.831v-6.743
        C17.276-96.319,2.265-94.554-10.845-94.554z'
      />
      <path d='M-44.973-144.792v0.911c1.886,0.518,4.581,0.978,8.066,1.372c6.99,0.789,16.269,1.223,26.128,1.223
        c9.86,0,19.14-0.434,26.129-1.223c3.806-0.43,6.661-0.938,8.553-1.514v-0.838l0.901-0.376c0.621-0.259,0.852-0.455,0.919-0.526
        c0.002-0.031,0-0.062-0.001-0.1c-0.001-0.003-0.127-0.252-0.931-0.597l-0.889-0.381v-3.93
        c-0.544,0.179-3.167,3.597-6.845,3.973c-2.047,0.209-4.67-2.333-7.168-2.118c-2.245,0.193-4.379,3.148-6.704,3.314
        c-2.385,0.171-4.912-2.451-7.094-2.338c-2.652,0.137-4.979,2.994-6.86,2.994c-2.28,0-3.433-2.783-6.87-2.859
        c-2.06-0.045-4.512,2.659-6.989,2.552c-2.25-0.097-4.432-2.997-6.73-3.166c-2.392-0.177-5.013,2.364-7.146,2.089
        c-2.693-0.348-4.761-3.863-6.47-4.409v3.831l-0.929,0.365c-0.995,0.392-1.128,0.674-1.13,0.696c0,0.026-0.001,0.053,0,0.082
        c0.076,0.078,0.349,0.309,1.123,0.608L-44.973-144.792z'
      />
      <path d='M-10.657-169.325c-4.528,0-13.091-0.44-13.091-2.108c0-1.666,8.563-2.106,13.091-2.106
        c4.527,0,13.089,0.44,13.089,2.106C2.432-169.765-6.13-169.325-10.657-169.325z M-10.657-173.039
        c-8.267,0-12.591,1.046-12.591,1.606c0,0.561,4.324,1.608,12.591,1.608c8.266,0,12.589-1.047,12.589-1.608
        C1.932-171.993-2.392-173.039-10.657-173.039z'
      />
      <path d='M-10.539-85.5c-17.648,0-36.405-2.786-36.405-7.948v-7.741c-1.275-1.049-1.921-2.201-1.921-3.427
        c0-1.25,0.646-2.417,1.921-3.47v-4.225c-1.163-0.927-1.751-1.946-1.751-3.033c0-1.132,0.589-2.169,1.751-3.087v-3.604
        c-1.246-0.77-1.853-1.656-1.853-2.705c0-1.056,0.606-1.946,1.853-2.714v-5.447c-1.967-1.018-1.967-2.056-1.967-2.566
        c0-1.026,0.645-1.869,1.967-2.568v-5.474c-1.894-0.811-2.059-1.658-2.059-2.395c0-1.281,1.097-1.976,2.059-2.395v-9.575
        c0-0.042,0.005-0.084,0.016-0.124c-0.01-0.104-0.016-0.189-0.016-0.275c0-4.921,8.991-9.215,22.945-10.982v-2.178
        c0-2.243,11.113-2.356,13.341-2.356c2.228,0,13.339,0.114,13.339,2.356v2.147c14.1,1.75,23.183,6.056,23.183,11.013
        c0,0.094-0.007,0.188-0.016,0.28c0.011,0.038,0.016,0.078,0.016,0.119v9.686c1.225,0.593,1.822,1.343,1.822,2.284
        c0,0.701-0.147,1.507-1.822,2.287v5.707c1.163,0.673,1.729,1.474,1.729,2.443c0,0.77-0.217,1.595-1.729,2.441v5.738
        c1.072,0.729,1.615,1.586,1.615,2.548c0,0.984-0.529,1.821-1.615,2.552v3.964c1.003,0.872,1.512,1.839,1.512,2.88
        c0,1.031-0.508,1.996-1.512,2.87v4.59c1.117,0.999,1.683,2.097,1.683,3.267c0,1.137-0.566,2.217-1.683,3.213v7.955
        C25.865-88.286,7.109-85.5-10.539-85.5z M-45.944-157.762v9.798c0,0.206-0.125,0.39-0.317,0.465
        c-1.544,0.608-1.742,1.172-1.742,1.595c0,0.388,0,0.918,1.74,1.592c0.192,0.075,0.319,0.26,0.319,0.466v6.118
        c0,0.192-0.11,0.368-0.284,0.451c-1.509,0.725-1.684,1.38-1.684,1.81c0,0.378,0,1.012,1.681,1.804
        c0.175,0.083,0.287,0.259,0.287,0.452v6.043c0,0.18-0.097,0.347-0.254,0.435c-1.076,0.608-1.599,1.26-1.599,1.993
        c0,0.463,0.166,1.172,1.599,1.985c0.157,0.089,0.253,0.255,0.253,0.435v4.137c0,0.159-0.076,0.309-0.204,0.403
        c-1.042,0.767-1.548,1.564-1.548,2.437c0,0.815,0.522,1.618,1.551,2.387c0.126,0.094,0.201,0.243,0.201,0.4v4.71
        c0,0.154-0.071,0.3-0.192,0.395c-1.147,0.894-1.729,1.848-1.729,2.835c0,0.962,0.581,1.901,1.728,2.792
        c0.122,0.095,0.193,0.241,0.193,0.395v7.981c0,3.286,14.54,6.948,35.405,6.948c20.864,0,35.404-3.662,35.404-6.948v-8.184
        c0-0.147,0.065-0.288,0.178-0.383c0.998-0.839,1.504-1.715,1.504-2.602c0-0.922-0.506-1.816-1.505-2.657
        c-0.113-0.095-0.178-0.235-0.178-0.382v-5.051c0-0.15,0.068-0.293,0.185-0.388c0.893-0.726,1.327-1.461,1.327-2.25
        c0-0.797-0.434-1.536-1.326-2.258c-0.117-0.095-0.186-0.238-0.186-0.389v-4.47c0-0.174,0.09-0.335,0.238-0.426
        c1.221-0.751,1.377-1.386,1.377-1.854c0-0.67-0.451-1.276-1.379-1.852c-0.147-0.091-0.236-0.252-0.236-0.425v-6.31
        c0-0.188,0.105-0.36,0.273-0.445c1.457-0.742,1.457-1.316,1.457-1.696c0-0.404-0.151-1.02-1.461-1.704
        c-0.165-0.086-0.269-0.257-0.269-0.443v-6.329c0-0.202,0.121-0.384,0.307-0.461c1.515-0.633,1.515-1.113,1.515-1.5
        c0-0.365-0.158-0.919-1.519-1.503c-0.184-0.079-0.303-0.26-0.303-0.459v-9.854c-0.026-0.067-0.037-0.139-0.029-0.21
        c0.016-0.138,0.029-0.24,0.029-0.342c0-4.401-9.14-8.449-22.742-10.074c-0.251-0.03-0.441-0.243-0.441-0.497v-2.521
        c-0.56-0.593-5.178-1.425-12.339-1.425c-7.163,0-11.781,0.832-12.341,1.425v2.551c0,0.253-0.188,0.466-0.439,0.496
        c-13.461,1.642-22.506,5.678-22.506,10.044c0,0.095,0.011,0.188,0.021,0.282C-45.915-157.918-45.922-157.837-45.944-157.762z'
      />
      <path d='M-6.547-171.285c-0.276,0-0.5-0.224-0.5-0.5v-2.569c0-0.081-0.065-0.146-0.146-0.146h-7.592
        c-0.08,0-0.145,0.065-0.145,0.146v2.569c0,0.276-0.224,0.5-0.5,0.5s-0.5-0.224-0.5-0.5v-2.569c0-0.632,0.514-1.146,1.145-1.146
        h7.592c0.632,0,1.146,0.514,1.146,1.146v2.569C-6.047-171.509-6.271-171.285-6.547-171.285z'
      />
      {!!low && (
        <g id='low' transform='translate(-10,-120) scale(.4)'>
          <Low />
        </g>
      )}
    </svg>
  )
}
